import React, { useState } from "react";
import smileEmoji from "../../../assets/images/smileIcon.png";
import neutralEmoji from "../../../assets/images/neutralIcon.png";
import sadEmoji from "../../../assets/images/sadIcon.png";
import useCanvasDetection from "../../hooks/useCanvasDetection";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import QuillionzProUpgradeModal from "../../components/modals/QuillionzProUpgradeModal";

const HelpingPointer = ({
  isSampleButtonClicked,
  content,
  handleTextAreaChange,
  handleUploadButtonClick,
  handleFileInputChange,
  handleYoutubeModalOpen,
  isFileUploaded,
  fileInputRef,
  userInfo
}) => {
  const [showTooltip, setShowTooltip] = useState(true);

  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const isCanvas = useCanvasDetection();

  const handleUploadLinkClick = () => {
    if (!userInfo.isFree) {
      handleUploadButtonClick();
      setShowTooltip(true); // Hide the tooltip when the link is clicked
    } else {
      setShowUpgradeModal(!0);
    }
  };

  return (
    <div
      className={`text-justify  ${
        isCanvas
          ? "md:mt-[-44%] lg:mt-[-38%] "
          : "md:mt-[-40%] sm:mt-[-80%] lg:mt-[-30%]"
      } ${isSampleButtonClicked ? "" : ""}`}
      value={content}
      onChange={handleTextAreaChange}
      // Disable the textarea if a valid file is uploaded
      disabled={isFileUploaded}
    >
      <div className="text-center  text-[#777e8d] ">
        {/* Title line of Helper Block */}
        <p className="text-[2rem] ">
          Hi there, just type or paste something here to get started.
        </p>{" "}
        <p className="text-2xl my-2">
          We’ve got a few pointers to help you along.
        </p>
      </div>

      <div className="flex gap-10 place-content-center py-4 text-[#777e8d]">
        {/* First Paragraph of Helper Block */}
        <div className=" w-1/3 ">
          <p className=" mb-4">
            <img className="block mx-auto opacity-40" src={smileEmoji} alt="" />
          </p>
          <p>
            Planning to create a test on WWII for your history class? Want a
            quiz on an encyclopedia article? Need questions on a product
            brochure?
          </p>
          <p className="mt-4">
            That’s perfect. Quillionz loves this sort of content! Go right
            ahead!
          </p>
        </div>

        {/* Second Paragraph of Helper Block */}
        <div className="w-1/3  ">
          <p className="mb-4">
            <img
              className="block mx-auto opacity-40"
              src={neutralEmoji}
              alt=""
            />
          </p>
          <p className="">
            Want to experiment with your class notes? An article from your
            favorite travel blog? Or{" "}
            {showTooltip ? (
              <Tooltip
                title="File size should be less than 10MB."
                arrow
                placement="top"
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
              >
              {userInfo?.version === 'PRO' || userInfo?.version === 'Free'? 
              <span
                className="cursor-pointer hover:underline text-[#f4833d]"
                onClick={handleUploadLinkClick}
              >
                Upload a PDF?
              </span>
               :
              <span
                className="cursor-pointer hover:underline text-[#f4833d]"
                onClick={handleUploadLinkClick}
              >
               Upload a PDF/docx?
              </span>
              }
              </Tooltip>
            ) : (
              <span
                className="cursor-pointer hover:underline text-[#f4833d]"
                onClick={handleUploadLinkClick}
              >
              {userInfo?.version === 'PRO' || userInfo?.version === 'Free'? <p> Upload a PDF?</p> : <p> Upload a PDF/docx?</p>}
              </span>
            )}
            <span>
              <input
                type="file"
                style={{ display: "none" }}
                ref={fileInputRef}
                accept="application/pdf"
                onChange={handleFileInputChange}
              />
            </span>
            {/* TODO : The 'Upload YouTube' feature will be implemented at a later stage, after the initial launch. For now, this aspect is being set aside. */}
           {/* <span className="">or</span>{" "}*/}
           {/*<span
              className=" cursor-pointer text-justify hover:underline text-[#f4833d] "
              onClick={handleYoutubeModalOpen}
            >
              Enter a YouTube link with closed captions.
            </span>*/}
          </p>
          <p className="mt-4">
            Sure, give it a shot. Just be patient, it may take some work to get
            it right.
          </p>
        </div>

        {/* Third Paragraph of Helper Block */}
        <div className=" w-1/3 ">
          <p className="text-center mb-4">
            <img className="block mx-auto opacity-40" src={sadEmoji} alt="" />
          </p>
          <p>
            Want to try a poem? A sonnet? A cool YouTube video or a Harry
            Potter? Umm, not the best idea, unless you’re feeling brave…
          </p>
          <p className="mt-4">
            Sure, give it a shot. Just be patient, it may take some work to get
            it right.
          </p>
        </div>
      </div>
      <QuillionzProUpgradeModal
          isOpen={showUpgradeModal} // Pass the state to control whether the modal is open or not
          onClose={setShowUpgradeModal} // Pass the function to close the modal and redirect
        />
    </div>
  );
};

export default HelpingPointer;
